import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {VehicleState, Response} from '../models/models';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VehicleStateService {

  constructor(private httpClient: HttpClient) { }

  getVehicleStates(): Observable<Response<VehicleState[]>> {
    return this.httpClient.get<Response<VehicleState[]>>(environment.apiPath + 'VehicleState');
  }

  getVehicleStatesForStatusGridByTraders(traderType: number, traderIds: string, daysBack: number, userId: number): Observable<Response<VehicleState[]>> {
    return this.httpClient.post<Response<VehicleState[]>>(environment.apiPath + 'VehicleState/getVehicleStatesForStatusGridByTraders', {traderType, traderIds, daysBack, userId});
  }

  getVehicleStatesForStatusGridByReferences(chassisNumber: string, referenceNumber: string, userId: number): Observable<Response<VehicleState[]>> {
    return this.httpClient.post<Response<VehicleState[]>>(environment.apiPath + 'VehicleState/getVehicleStatesForStatusGridByReferences', {chassisNumber, referenceNumber, userId});
  }

  getVehicleStatesForDamageReportGrid(userId: number): Observable<Response<VehicleState[]>> {
    return this.httpClient.get<Response<VehicleState[]>>(environment.apiPath + 'VehicleState/' + userId + '/UserId');
  }

  getVehicleStatesForDamageReportOverviewGrid(userId: number): Observable<Response<VehicleState[]>> {
    return this.httpClient.get<Response<VehicleState[]>>(environment.apiPath + 'VehicleState/' + userId + '/UserId/Overview');
  }

  getVehicleStatesForDamageReportClosedGrid(userId: number): Observable<Response<VehicleState[]>> {
    return this.httpClient.get<Response<VehicleState[]>>(environment.apiPath + 'VehicleState/' + userId + '/UserId/Closed');
  }
}
